import { useEffect, useState } from 'react'
import { CTA_CTE } from '../../constants/mediosEnviosPagos.js'
import { ID_PERFIL_VENDEDOR } from '../../constants/perfiles.js'
import { toastErrorLog } from '../../helpers/toastErrorLog.js'
import { useAuth } from '../../hooks/useAuth'
import * as usuarioService from '../servicios/usuarioService'

const vendedoresCtacte = new Map()

const obtenerVendedoresCtaCte = (empid) => {
  if (!vendedoresCtacte.has(empid)) {
    vendedoresCtacte.set(
      empid,
      usuarioService
        .obtenerVendedoresCtaCte(empid)
        .then(({ data }) => data)
        .catch((error) => {
          vendedoresCtacte.delete(empid)
          throw error
        })
    )
  }
  return vendedoresCtacte.get(empid)
}

const obtenerIdsMediosPago = (publicacion) =>
  publicacion?.mediosPagos?.map((medio) =>
    typeof medio === 'object' ? medio.idMedioPago : Number(medio)
  ) || []

export const useDeshabilitaCompra = (publicacion = {}) => {
  const esArray = Array.isArray(publicacion)
  const { loginDataContext: { idPerfil, empid } = {} } = useAuth()
  const [vendedoresHabilitados, setVendedoresHabilitados] = useState([])
  const [deshabilitaPorPerfil, setDeshabilitaPorPerfil] = useState(true)

  useEffect(() => {
    if (!empid) return
    obtenerVendedoresCtaCte(empid)
      .then(setVendedoresHabilitados)
      .catch((error) =>
        toastErrorLog(error, 'Error al obtener vendedores con cuenta corriente', 'publicaciones')
      )
  }, [empid])

  useEffect(() => {
    if (!idPerfil) {
      setDeshabilitaPorPerfil(true)
      return
    }
    setDeshabilitaPorPerfil(idPerfil === ID_PERFIL_VENDEDOR)
  }, [idPerfil])

  const vendedorHabilitado = (empid) =>
    vendedoresHabilitados.some((v) => v.empidVendedor === empid && v.habilita)

  const tieneCtaCte = (item) => obtenerIdsMediosPago(item).includes(CTA_CTE)

  const soloTieneCtaCte = (item) => {
    const ids = obtenerIdsMediosPago(item)
    return ids.length === 1 && ids[0] === CTA_CTE
  }

  const deshabilitarCompraCtaCte = (item) => {
    if (!empid) return false
    return soloTieneCtaCte(item) && !vendedorHabilitado(empid)
  }

  const mostrarAvisoCompra = (item) => {
    if (!empid) return false
    return !vendedorHabilitado(empid) && tieneCtaCte(item)
  }

  if (esArray) {
    const idsDeshabilitados = new Set(
      publicacion.filter(deshabilitarCompraCtaCte).map((item) => item.idPublicacion)
    )
    return { idsDeshabilitados }
  }

  return {
    deshabilitaCompra: deshabilitarCompraCtaCte(publicacion),
    mostrarAvisoCompra: mostrarAvisoCompra(publicacion),
    deshabilitaCompraPorPerfil: deshabilitaPorPerfil
  }
}
